import { z } from "zod";
import type { Operation } from "../types";

// Dock agent picker (docs/acp/PRD.md §5.4 M3). Agent-first; model submenu only
// for model-backed agents (harness). Reads/writes agents.json > acp surfaces.

const agentOption = z.object({
  id: z.string(),
  label: z.string(),
  modelBacked: z.boolean(),
  disabled: z.boolean(),
});
export type AcpDockAgentOption = z.infer<typeof agentOption>;

const getResponse = z.object({
  /** agents.acp.enabled (or EXCELLENT_ACP) — when false, UI keeps legacy model picker. */
  enabled: z.boolean(),
  selectedAgent: z.string(),
  agents: z.array(agentOption),
});
export type AcpDockGetResponse = z.infer<typeof getResponse>;

const get: Operation<void, void, void, AcpDockGetResponse> = {
  method: "GET",
  path: () => "/api/agents/acp-dock",
  response: getResponse,
};

const setBody = z.object({
  agentId: z.string().min(1).max(64),
});
export type AcpDockSetBody = z.infer<typeof setBody>;

const setResponse = z.object({
  selectedAgent: z.string(),
});
export type AcpDockSetResponse = z.infer<typeof setResponse>;

const set: Operation<void, void, AcpDockSetBody, AcpDockSetResponse> = {
  method: "POST",
  path: () => "/api/agents/acp-dock",
  body: setBody,
  response: setResponse,
};

export const acpDock = { get, set };
